<style lang="scss">
  .guided-session{
    $header-height: 64px; //  header height (var does not work in calc)
    $offset-top: 20px;

    &__content{
      margin-top: $header-height;

      &__sounds{
        width: 300px;
        height: calc(100vh - 64px); // header height

        .instructor-panel{
          margin-top: $offset-top;
        }
      }

      &__back {
        .icon-wrapper{
          border-radius: 100%;
        }
      }

      &__back {
        height: 90px;
        width: 105px;
        background-color: white;
        border-bottom-left-radius: $small-curve;
        border-top-left-radius: $small-curve;
        @include positioningOffset(absolute, $header-height + $offset-top, 0, unset, unset);
      }
    }
  }
</style>
<template>
  <div class="guided-session">

    <div class="background-full" :style="{backgroundImage: `url(${getAssetUrl('images/guided-meditation.jpg')})`}"></div>

    <article class="guided-session__content">
      <section
              class="guided-session__content__sounds p-relative animate__animated animate__faster">
        <session-panel @finish="endSession()"
                :stop-all="stopSound" v-if="activeInstructor" :instructor="activeInstructor"></session-panel>
      </section>


      <section @click="goBack()"
              class="guided-session__content__back p-relative d-flex justify-center align-center
              animate__slideInRight
               pointer animate__animated animate__faster">
        <div class="icon-wrapper purple-background pa-2">
          <v-icon large color="white">
            mdi-reply
          </v-icon>
        </div>
      </section>

    </article>
  </div>
</template>

<script>
  // eslint-disable-next-line no-unused-vars
  import { Howl } from 'howler';
  import GuidedMeditationService from '../../services/GuidedMeditationService';
  import SessionPanel from '../../components/guideMeditation/SessionPanel';

  export default {
    name: 'guidedsession',
    props: {
      instructorId: {
        required: true,
        type: String,
      }
    },
    components: {
      SessionPanel,
    },
    computed: {},
    data() {
      return {
        redirect: 'dashboard',
        instructors: GuidedMeditationService.getInstructors(),
        activeInstructor: null,
        stopSound: false,
      };
    },
    beforeRouteLeave(to, from, next) {
      this.$store.dispatch('setFullscreenMode', false);
      next();
    },
    mounted() {
      this.requestWakeLock();

      let instructor = GuidedMeditationService.getInstructorById(this.instructorId);

      if(instructor) {
        this.setActiveInstructor(instructor);
        this.sendLog('GuidedMeditationStart', `Started a guided mediation session with ${instructor.name}`, {instructor: instructor});
      }
    },
    beforeDestroy() {
      this.releaseWakeLock();
      if (this.activeInstructor) {
        this.sendLog('GuidedMeditationEnd', `Exited guided meditation session with ${this.activeInstructor.name}`, {instructor: this.activeInstructor});
      }
    },
    methods: {
      getAssetUrl(url) {
        if(url) {
          return require('../../assets/'+ url);
        }
      },
      setActiveInstructor(newInstructor){
        this.activeInstructor = newInstructor;
      },
      goBack() {
        this.$router.push({name: 'guided-meditation'});
      },
      stopSounds() {
        this.stopSound = true; // turn off all sounds
      },
      endSession() {
        this.stopSounds();
        this.sendLog('GuidedMeditationEnd', `Finished guided meditation session with ${this.activeInstructor.name}`, {instructor: this.activeInstructor});
        // play end session sound (bell ding/chime)
        // new Howl({
        //   src: this.getAssetUrl('sounds/other/finish.wav'),
        //   html5: true,
        //   loop: false,
        //   autoplay: true
        // });
      },
      sendLog(action, description, meta = null) {
        this.$store.dispatch('stats/sendLog', {
          action: action,
          description: description,
          meta: meta
        });
      },
      async requestWakeLock() {
        try {
          if ('wakeLock' in navigator) {
            this.wakeLock = await navigator.wakeLock.request('screen');
          } else {
            console.warn('Wake Lock API not supported');
          }
        } catch (err) {
          console.error(`Failed to request wake lock: ${err.name}, ${err.message}`);
        }
      },
      async releaseWakeLock() {
        if (this.wakeLock) {
          await this.wakeLock.release();
          this.wakeLock = null;
        }
      },
    },
  }
</script>
